import { render, staticRenderFns } from "./qandaList.vue?vue&type=template&id=9bd31e40&scoped=true&"
import script from "./qandaList.vue?vue&type=script&lang=js&"
export * from "./qandaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd31e40",
  null
  
)

export default component.exports